import "./UserPat.module.css";
import Header from "@/reusable_sections/Header";
import PatFamily from "./sections/PatFamily";
import Capabilities from "./sections/Capabilities";
import FamilyShowcase from "./sections/FamilyShowcase";
import PatCta from "./sections/PatCta";
import Footer from "@/reusable_sections/Footer";
export default function UserPatPage() {
  return <div>
      <Header />
      <PatFamily />
      <Capabilities />
      <FamilyShowcase />
      <PatCta />
      <Footer />
    </div>;
}